import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from '../../../../UI/Button/Button';
import {hideOverlay} from '../../../actions/overlay-actions';
import Translation from '../../../lang/Translation';
import ResidentIDHelper from '../../helpers/ResidentIDHelper';
import CheckoutOverlay from '../CheckoutOverlay';
import useStyles from './Overlay.styles';

export function PassportNumberOverlay(props) {
  const classes = useStyles();
  return (
    <CheckoutOverlay
      popup
      className={classes.overlay}
      data-test="PassportNumberOverlay"
      title="checkout.address.field.label.korean.passport.title"
    >
      <ResidentIDHelper isOverlay />
      <div
        className={classes.buttonContainer}
        data-test="PassportNumberOverlay__buttonContainer"
      >
        <Button
          id="PassportNumberOverlay__closeButton"
          className="PassportNumberOverlay__closeButton"
          primary
          fullWidth
          onClick={props.hideOverlay}
        >
          <Translation>checkout.close.button</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

PassportNumberOverlay.propTypes = {
  hideOverlay: PropTypes.func.isRequired,
};

export default connect(null, {hideOverlay})(PassportNumberOverlay);
